<h1 class="obg-m-poker-login-verification-title">
	{{ "poker-inclient." + currentStep + ".title" | translate }}
</h1>

<p class="obg-m-poker-login-verification-description">
	{{ descriptionContent }}
</p>

<a
	[obgRouteLink]="actionUrlLink"
	class="obg-m-poker-login-verification-button"
	color="primary"
	mat-raised-button
	rel="noreferrer noopener"
	target="_blank"
	(click)="action.emit()"
	*ngIf="showActionButton"
>
	{{
		(currentStep === "jurisdiction-mismatch"
			? "poker-inclient.jurisdiction-mismatch.action-text"
			: "general.continue"
		) | translate
	}}
</a>
